import { Icon } from "@introist/react-foundation/v2";
import { TasksListRoute } from "./routes/TasksListRoute";
import { TaskRoute } from "./routes/TaskRoute";

export const TASKS_ROUTES = {
  tasks: {
    key: "route-tasks",
    title: "Tasks",
    icon: <Icon name="check" />,
    path: "/tasks",
    element: <TasksListRoute />
  },
  task: {
    key: "route-task",
    title: "Task",
    path: "/tasks/:id",
    element: <TaskRoute />
  }
};
